import {platformAPI} from "../../../api/axiosConfig";
import {HotlineNumber} from "../typedefs";
import {useQuery} from "react-query";

async function fetchNumber(id: string | undefined) {
    if (!id){
        return null
    }
    const res = await platformAPI.get<HotlineNumber>(`api/hotline-numbers/${id}`)

    return res.data

}


export function useGetNumber(id: string | undefined) {

    const {data, isLoading, error, refetch} = useQuery(
        ["hotline-number", id],
        () => fetchNumber(id),
        {
            enabled: !!id,
            cacheTime: 0,
            refetchOnMount: true,
        }
    );

    return {
        data,
        isLoading,
        error,
        refetch
    }


}